import React, { useState } from 'react';
import SkillMap from './SkillMap';
import SkillDetailsPanel from './SkillDetailsPanel';
import './skills-neural.css'; // We'll create this CSS file

const SkillsSection = () => {
    const [selectedCategory, setSelectedCategory] = useState(null);

    return (
        <div className="skills-neural-container">
            <div className="skills-neural-layout">
                <div className="skills-map-wrapper">
                    <SkillMap
                        selectedCategory={selectedCategory}
                        onSelectCategory={setSelectedCategory}
                    />
                </div>
                <div className="skills-panel-wrapper">
                    <SkillDetailsPanel selectedCategory={selectedCategory} />
                </div>
            </div>
        </div>
    );
};

export default SkillsSection;
